import { render, staticRenderFns } from "./inspect.vue?vue&type=template&id=4ce570bb&scoped=true"
import script from "./inspect.vue?vue&type=script&lang=js"
export * from "./inspect.vue?vue&type=script&lang=js"
import style0 from "./inspect.vue?vue&type=style&index=0&id=4ce570bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce570bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce570bb')) {
      api.createRecord('4ce570bb', component.options)
    } else {
      api.reload('4ce570bb', component.options)
    }
    module.hot.accept("./inspect.vue?vue&type=template&id=4ce570bb&scoped=true", function () {
      api.rerender('4ce570bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/cmp/inspect.vue"
export default component.exports